<template>
  <div style="background-color: white">
    <div class="pageHeader text-center">
      <img
          src="@/assets/newPreSession/preSessionSuccess.png"
          alt=""
          class="headerImage"
      />

      <div
          :class="
          !$vuetify.breakpoint.smAndDown
            ? 'title-medium-20'
            : 'body-large-18-medium'
        "
          class="mt-4"
          style="color: #212121"
      >
        {{$t("newPreSession.successMessage")}}

      </div>
      <div
          :class="
          !$vuetify.breakpoint.smAndDown
            ? 'body-large-18-medium '
            : 'body-medium-16-regular'
        "
          class="mt-2"
          style="color: #212121"
      >
        {{$t("newPreSession.supportMessage")}}

       </div>

      <div class="alertArea d-flex flex-column justify-center pt-2 mt-5">
        <div class="d-flex">
          <div>
            <img src="../../assets/newPreSession/cart/circle-check-filled.svg" alt="">
          </div>
          <div class="mr-2" style="padding-top: 2px;">
            {{$t("newPreSession.sessionScheduled")}}

           </div>
        </div>
      </div>

      <div class="contentBox">
        <div
            :class="[
            !$vuetify.breakpoint.smAndDown
              ? 'title-medium-20'
              : 'body-large-18-medium',$vuetify.rtl ? 'text-right' : 'text-left']"


        >
          {{$t("newPreSession.sessionInfo")}}


        </div>

        <div class="divider"></div>

        <v-row no-gutters class="therapistSection">
          <v-col cols="2" lg="1">
            <img :src="counselorData?.avatar" alt="" class="therapistAvatar"/>
          </v-col>
          <v-col cols="10" lg="11" :class="$vuetify.rtl ? 'text-right' : 'text-left'">
            <div class="body-small-14-medium mr-1" style="color: #616161">
              {{$t("newPreSession.evaluationSpecialist")}}

             </div>
            <div class="title-small-18 mt-2 mr-1" style="color: #212121">
              {{$vuetify.rtl ? counselorData?.name :  counselorData.en_name}}

            </div>
          </v-col>
        </v-row>

        <div class="desSection " :class="$vuetify.rtl ? 'text-right' : 'text-left'">
          <div
              class="eachDesSection body-medium-16-medium"
              style="color: #424242"
          >
            <img
                src="@/assets/newPreSession/calendar.png"
                alt=""
                class="eachIcons"
            />
            {{ this.date }}
          </div>
          <div
              class="eachDesSection body-medium-16-medium"
              style="color: #424242"
          >
            <img
                src="@/assets/newPreSession/monitor.png"
                alt=""
                class="eachIcons"
            />
            {{$t("newPreSession.evaluationSession")}}

           </div>
          <div class="eachDesSection" style="color: #424242">
            <img
                src="@/assets/newPreSession/time.png"
                alt=""
                class="eachIcons"
            />
            {{ this.timezone }}
          </div>
          <div
              class="eachDesSection body-medium-16-medium"
              style="color: #424242"
          >
            <div class="d-flex align-center">
              <img
                  src="@/assets/newPreSession/blueInfo.png"
                  alt=""
                  class="eachIcons"
              />
              <span
                  class="body-large-18-medium"
                  v-if="!$vuetify.breakpoint.mobile"
                  dir="rtl"
              >
              {{$t("newPreSession.yourEvaluationSession")}}
              {{$vuetify.rtl ? $t("newPreSession.platform") : $t("newPreSession.heldIn")}}



                <a
                    target="_blank"
                    class="body-medium-16-medium"
                    style="margin: 0 5px; text-decoration: none"
                    href="https://www.microsoft.com/en-us/microsoft-teams/group-chat-software"
                >
                                <span style="text-decoration: none;font-weight: bold !important" dir="ltr" class="body-large-18-medium">Teams</span>

                </a>

          {{$vuetify.rtl ? $t("newPreSession.heldIn") : $t("newPreSession.platform")}}
              </span>

              <span class="body-large-18-medium" v-else dir="rtl">
                <span class="body-medium-16-medium">{{$vuetify.rtl ? $t("newPreSession.in") : ""}}</span>
                <span class="body-medium-16-medium">{{$vuetify.rtl ? "" : $t("newPreSession.heldIn")}}</span>

                <a
                    target="_blank"
                    class="body-medium-16-medium"
                    style="margin: 0 5px; text-decoration: none"
                    href="https://www.microsoft.com/en-us/microsoft-teams/group-chat-software"
                >
                {{$vuetify.rtl ? $t("newPreSession.platform") : ""}}

                   <span dir="ltr">Teams</span>
                {{!$vuetify.rtl ? $t("newPreSession.platform") : ""}}

                  <span class="body-medium-16-medium">{{$vuetify.rtl ? $t("newPreSession.heldIn") : ""}}</span>

                </a>
              </span>
            </div>
            <div v-if="!$vuetify.breakpoint.mobile" class="d-flex align-center">
              <a :href="teamsGooglePlayLink">
                <img
                    src="@/assets/newPreSession/googlePlay.png"
                    alt=""
                    class="eachStoreImage"
                />
              </a>
              <a :href="teamsAppleStoreLink">
                <img
                    src="@/assets/newPreSession/apple.png"
                    alt=""
                    class="eachStoreImage"
                />
              </a>
            </div>
            <div
                class="d-flex flex-grow-1 justify-end align-center body-medium-16-medium text-center"
                style="color: #035184"
                v-else
            >
              <div
                  class="body-medium-16-medium"
                  @click="downloadInfoModal = true"
              >

                {{$t("newPreSession.downloadLink")}}
              </div>
              <img
                  src="@/assets/newPreSession/arrowLeft.png"
                  alt=""
                  class="arrowLeft"
                  :style="{'transform' : !$vuetify.rtl ? 'rotate(180deg)' : '' }"

              />
            </div>
          </div>
        </div>

        <div class="addCalendarSection">
          <div class="centered-divider">
            <div class="divider-line"></div>
            <div class="divider-text body-medium-16-medium">{{$t("newPreSession.addTo")}}</div>
            <div class="divider-line"></div>
          </div>
        </div>
        <div class="calendarSection">
          <img
              @click="openCalendarLink('yahoo')"
              src="@/assets/newPreSession/yahoo.png"
              alt=""
              class="eachCalendar"
          />
          <img
              @click="openCalendarLink('google')"
              src="@/assets/newPreSession/googleCalendar.png"
              alt=""
              class="eachCalendar"
          />
          <img
              @click="openCalendarLink('outlook')"
              src="@/assets/newPreSession/outlook.png"
              alt=""
              class="eachCalendar"
          />
        </div>
      </div>

      <div v-if="!$vuetify.breakpoint.smAndDown" class="contentBox footerDiv">
        <div>
          {{$t("newPreSession.messageForSession")}}
         </div>
        <div class="d-flex flex-row align-start justify-space-between">
          <div class="body-medium-16-medium text-right footerTextSection">
            <v-checkbox
                v-model="confirmBtn"
                :label="$t('newPreSession.messageFirst')"
            ></v-checkbox>
          </div>
          <!--          //desktop-->

            <v-btn
                :to="`/${$vuetify.rtl ? 'fa' : 'en'}/portal/home`"
                elevation="0"
                :disabled="!confirmBtn"
                id="new-pre-session-step-four-panel"
                style="text-decoration: none !important"
                class="d-flex  flex submitButton mt-3 title-small-16"
            >
              {{$t("newPreSession.confirmAndContinue")}}
            </v-btn>
        </div>
      </div>
      <div
          v-else
          class="contentBox contentBoxCustomized d-flex flex-column align-center"
      >
        <div class="mt-2 mb-3 body-medium-16-regular">
          {{$t("newPreSession.messageForSession")}}

        </div>
        <v-checkbox
            v-model="confirmBtn"
            :label="$t('newPreSession.messageFirst')"
        ></v-checkbox>

        <v-btn
            to="/fa/portal/home"
            elevation="0"
            block
            :disabled="!confirmBtn"
            id="new-pre-session-step-four-panel"
            class="d-flex  flex submitButton mt-3 title-small-16"
        >
          {{$t("newPreSession.confirmAndContinue")}}


         </v-btn>
      </div>
    </div>
    <v-bottom-sheet v-model="downloadInfoModal">
      <div class="sessionDetailModal">
        <div class="sessionDetailHeader">
          <div class="d-flex flex-column justify-center">
            <img
                src="@/assets/newPreSession/info.png"
                alt=""
                class="smallIcon"
            />
          </div>
          <div
              class="body-large-18-medium d-flex flex-column justify-center flex-grow-1 mt-1 mr-2 title-small-16"
          >
            {{$t("newPreSession.downloadModalTitle")}}
          </div>
          <div class="d-flex flex-column justify-center">
            <img
                @click="downloadInfoModal = false"
                src="@/assets/newPreSession/cross.png"
                alt=""
                class="smallIcon"
            />
          </div>
        </div>
        <div class="divider"></div>
        <div
            class="theInfoSection body-medium-16-regular"
            style="color: #424242"
        >
          {{$t("newPreSession.downloadLinksMessage")}}

        </div>
        <div class="d-flex align-start justify-start mt-2">
          <a :href="teamsGooglePlayLink">
            <img
                src="@/assets/newPreSession/googlePlay.png"
                alt=""
                class="eachStoreImage"
            />
          </a>
          <a :href="teamsAppleStoreLink">
            <img
                src="@/assets/newPreSession/apple.png"
                alt=""
                class="eachStoreImage"
            />
          </a>
        </div>
        <div class="bottomMargin"></div>
      </div>
    </v-bottom-sheet>
  </div>
</template>

<script>
import moment from "moment-timezone";
import EventsMixins from "@/mixins/EventsMixins";

export default {
  data() {
    return {
      confirmBtn: false,
      google: null,
      outlook: null,
      yahoo: null,
      timezone: "",
      date: "",
      time: null,
      web_engage_time: null,
      teamsGooglePlayLink:
          "https://play.google.com/store/apps/details?id=com.microsoft.teams&pcampaignid=web_share",
      teamsAppleStoreLink:
          "https://apps.apple.com/us/app/microsoft-teams/id1113153706",
      downloadInfoModal: false,
    };
  },
  props: {
    finalDate: {
      type: Object,
    },
    counselorData: {
      type: Object,
    },
  },
  mixins: [EventsMixins],
  async mounted() {
    this.$emitEvent("setLoading", true);

    try {
      await this.requesting("auth", "getProfile");

      this.getCalendarLinks();
    } finally {
      this.$emitEvent("setLoading", false);
    }
  },

  methods: {
    convertTZ(time, tz) {
      let current = moment.tz(time, "YYYY/MM/DD HH:mm", tz);
      return current.clone().utc();
    },
    extractDateTime(text) {
      const dateRegex = /\d{4}\/\d{2}\/\d{2}/;
      const timeRegex = /(\d{2}:\d{2})\s*(صبح|عصر|شب|AM|PM)?/;

      const dateMatch = text.match(dateRegex);
      const timeMatch = text.match(timeRegex);

      return {
        date: dateMatch ? dateMatch[0] : null,
        time: timeMatch ? timeMatch[1] : null,
        label: timeMatch ? timeMatch[2] || null : null,
      };
    },
    getCalendarLinks() {
      const finalDate = this.finalDate.date.split(","); // ["چهارشنبه 2025/05/02 ساعت 15:14", "Asia/Tehran"]
      const rawText = finalDate[0];
      const timezone = finalDate[1].replace(/[()]/g, "").trim();

      this.timezone = timezone;
      this.date = rawText;

      const {date, time} = this.extractDateTime(rawText); // e.g., "2025/05/02", "15:14"

      this.WebEngagePreSessionSet({
        date: new Date(),
        session_date: date,
        session_time: time,
        timezone: timezone,
      });

      const momentStart = this.convertTZ(`${date} ${time}`, timezone);
      const momentEnd = momentStart.clone().add(30, "minutes");

      const start = momentStart.format("YYYYMMDDTHHmmss") + "Z";
      const end = momentEnd.format("YYYYMMDDTHHmmss") + "Z";

      const title = encodeURIComponent("meeting");
      const details = encodeURIComponent(
          "your online pre session in simiaroom"
      );

      this.google = `https://www.google.com/calendar/render?action=TEMPLATE&text=جلسه پیش‌مشاوره&dates=${start}/${end}&details=Event%20Description&location=Event%20Location`;
      this.outlook = `https://outlook.live.com/calendar/0/deeplink/compose?path=/calendar/action/compose&rru=addevent&startdt=${momentStart.toISOString()}&enddt=${momentEnd.toISOString()}&subject=${title}&body=${details}&location=${location}`;
      this.yahoo = `https://calendar.yahoo.com/?v=60&view=d&type=20&title=${title}&st=${start}&et=${end}&desc=${details}&in_loc=${location}`;
    },

    formatDateTime(datetime) {
      return moment(datetime).utc().format("YYYYMMDDTHHmmss") + "Z";
    },

    formatYahooDateTime(datetime) {
      return moment(datetime).format("YYYYMMDDTHHmmss");
    },

    openCalendarLink(type) {
      window.open(this[type], "_blank");
    },
  },
};
</script>

<style scoped>
.alertArea {
  padding: 0 16px;
  background: rgba(202, 234, 212, .5);
  width: 693px;
  height: 50px;
  margin: 0 auto;
  color: #2ead56;
  font-size: 15px;
  border-radius: 8px;
}

.sessionDetailHeader {
  display: flex;
  flex-direction: row;
  padding: 16px 0;
}

.divider {
  width: 100%;
  height: 1px;
  background-color: #eaf0f6;
}

.sessionDetailModal {
  width: 100%;
  height: 248px;
  padding: 0 24px;
  background-color: white;
  border-top-right-radius: 25px;
  border-top-left-radius: 25px;
}

.theInfoSection {
  margin-top: 16px;
}

@media (min-width: 200px) and (max-width: 600px) {

  .alertArea {
    width: auto !important;
    height: auto;
    border: 1px solid #eaf0f6;
    margin: 16px 24px !important;
  }

  .eachStoreImage {
    width: 140px !important;
    height: 43px !important;
  }

  .smallIcon {
    width: 20px;
    height: 20px;
  }

  .submitButton {
    width: 95% !important;
    height: 40px !important;
    border-radius: 8px !important;
  }

  .eachCalendar {
    width: 34px !important;
    height: 34px !important;
    margin: 0 16px;
  }

  .therapistSection {
    width: 100% !important;
    height: 72px;
    margin: 16px 0;
    border-radius: 4px;
  }

  .headerImage {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 90px !important;
    height: 80px !important;
    margin-top: 50px !important;
  }

  .contentBox {
    width: auto !important;
    height: auto;
    border: 1px solid #eaf0f6;
    border-radius: 10px;
    padding: 16px !important;
    margin: 16px 24px !important;
  }

  .contentBoxCustomized {
    width: auto !important;
    height: auto;
    border: 1px solid #eaf0f6;
    border-radius: 10px;
    padding: 7px !important;
    margin: 16px 24px !important;
  }
}

.headerImage {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 120px;
  height: 106px;
  margin-top: 50px;
}

.contentBox {
  width: 693px;
  height: auto;
  border: 1px solid #eaf0f6;
  margin: 32px auto 16px auto;
  border-radius: 10px;
  padding: 16px 24px;
}

.divider {
  width: 100%;
  height: 1px;
  background-color: #eaf0f6;
  margin: 16px 0;
}

.therapistSection {
  border-radius: 4px;
  background-color: #f6f9fc;
  width: 100%;
  height: 72px;
  margin: 16px 0;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.therapistAvatar {
  width: 34px;
  height: 34px;
  margin-right: 2px;
  border-radius: 18px;
}

.eachIcons {
  width: 30px;
  height: 30px;
}

.arrowLeft {
  width: 18px;
  height: 18px;
  margin-right: 4px;
}

.desSection {
}

.eachDesSection {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 18px;
}

.centered-divider {
  display: flex;
  align-items: center;
  width: 100%;
  margin: 24px 0;
}

.divider-line {
  flex: 1;
  height: 2px;
  background: #eaf0f6;
  border-radius: 2px;
}

.divider-text {
  margin: 0 16px;
  color: #757575;
  white-space: nowrap;
}

.eachCalendar {
  width: 48px;
  height: 48px;
  margin: 0 16px;
  cursor: pointer;
  transition: background-color 0.3s ease, box-shadow 0.3s ease,
  border-radius 0.3s ease;
}

.eachCalendar:hover {
  background-color: #d7f4e9; /* light greenish background */
  border-radius: 50px; /* smooth corners */
  box-shadow: 0 2px 8px rgba(57, 201, 144, 0.45); /* subtle green shadow */
}

.submitButton {
  text-decoration: none !important;
  cursor: pointer;
  width: 223px !important;
  height: 48px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #39c990 !important;
  color: white !important;
  border-radius: 10px;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

.footerDiv {
  height: auto !important;
}

.footerTextSection {
  width: 332px;
  margin-left: 8px;
}

.submitButton:hover {
  background-color: #2ebd84; /* a slightly darker green */
  box-shadow: 0px 4px 12px rgba(57, 201, 144, 0.4); /* subtle greenish shadow */
}

.eachStoreImage {
  cursor: pointer;
  width: 135px;
  height: 45px;
  margin-right: 6px;
}
</style>
